function Footer() {
  return <div className="bg-repeat-x bg-center bgLogin mt-10" />;
}

export default Footer;
